import React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

export const ImageLightbox = ({ open, onOpenChange, src, alt }) => (
  <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay
        data-testid="infrastructure-lightbox-overlay"
        className="fixed inset-0 z-50 bg-[#0B0B1A]/80 backdrop-blur-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
      />
      <DialogPrimitive.Content
        data-testid="infrastructure-lightbox-content"
        className="fixed left-1/2 top-1/2 z-50 w-[92vw] max-w-4xl -translate-x-1/2 -translate-y-1/2 focus:outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"
      >
        <DialogPrimitive.Title className="sr-only">{alt || 'Enlarged image'}</DialogPrimitive.Title>
        <DialogPrimitive.Description className="sr-only">
          Enlarged infrastructure photo. Press Escape or use the close button to dismiss.
        </DialogPrimitive.Description>
        {src && (
          <img
            src={src}
            alt={alt}
            data-testid="infrastructure-lightbox-image"
            className="max-h-[85vh] w-full rounded-xl object-contain shadow-2xl"
          />
        )}
        <DialogPrimitive.Close
          data-testid="infrastructure-lightbox-close"
          aria-label="Close enlarged image"
          className="absolute -top-4 -right-4 sm:-top-5 sm:-right-5 flex h-10 w-10 items-center justify-center rounded-full bg-white text-[#26247B] shadow-lg transition-colors duration-200 hover:bg-[#F4A300] hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#26247B]"
        >
          <X className="h-5 w-5" />
        </DialogPrimitive.Close>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  </DialogPrimitive.Root>
);
